import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Make React and ReactDOM available globally for admin.html
if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = ReactDOM;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);